import { List, Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { NebSectionBenefitsAttributes } from 'core/flow/entities';
import { IconStyled, ItemStyled, TypographyStyled } from './styled';

type BenefitsProps = {
  content: NebSectionBenefitsAttributes['content'];
};

export const Benefits = ({ content }: BenefitsProps) => {
  return (
    <>
      <TypographyStyled variant="h1" dangerouslySetInnerHTML={prepareHtml(content.title)} />
      <List spacing={4}>
        {content.list.map((text) => (
          <ItemStyled key={text}>
            <IconStyled name="check" width={20} height={20} />
            <Typography variant="bodyMediumRegular" dangerouslySetInnerHTML={prepareHtml(text)} />
          </ItemStyled>
        ))}
      </List>
    </>
  );
};
